import { gql } from "@urql/core";

export const PAYMENT_REQUEST_QUERY = gql`
  query PaymentRequests(
    $filter: JSONObject
    $sorting: [SortInput!]
    $paging: PaginationInput
  ) {
    paymentRequests(query:{filter: $filter, sorting: $sorting, paging: $paging}) {
      nodes {
        id
        invoiceId
        poNo
        receivingNo
        supplierId
        supplierName
        attachments {
          fileId
          originalName
          mimeType
          size
          category
        }
        amount
        currency
        exchangeRate
        dueDate
        priority
        bankAccountDetails {
          bank
          accountNo
        }
        status
        payment {
          voucherNumber
          paidAmount
          paymentDate
          method
          reference
        }
        createdBy
        updatedBy
        submittedBy
        submittedAt
        completedBy
        completedAt
        cancelledBy
        cancelledAt
        teamId
        tags
        notes
        externalWorkflow
        approvalData
        flowCaseId
        flowCaseNumber
        createdAt
        updatedAt
      }
    }
  }
`;

export const PAYMENT_REQUEST_BY_ID_QUERY = gql`
  query PaymentRequestById($id: String!) {
    paymentRequest(id: $id) {
      id
      invoiceId
      poNo
      receivingNo
      supplierId
      supplierName
      attachments {
        fileId
        originalName
        mimeType
        size
        category
      }
      amount
      currency
      exchangeRate
      dueDate
      priority
      bankAccountDetails {
        bank
        accountNo
      }
      status
      payment {
        voucherNumber
        paidAmount
        paymentDate
        method
        reference
      }
      createdBy
      updatedBy
      submittedBy
      submittedAt
      completedBy
      completedAt
      cancelledBy
      cancelledAt
      teamId
      tags
      notes
      externalWorkflow
      approvalData
      flowCaseId
        flowCaseNumber
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_PAYMENT_REQUEST_MUTATION = gql`
  mutation CreatePaymentRequest($input: CreatePaymentRequestInput!) {
    createPaymentRequest(input: $input) {
      id
      invoiceId
      poNo
      receivingNo
      supplierId
      supplierName
      amount
      currency
      exchangeRate
      dueDate
      priority
      bankAccountDetails {
        bank
        accountNo
      }
      status
      createdAt
    }
  }
`;

export const UPDATE_PAYMENT_REQUEST_MUTATION = gql`
  mutation UpdatePaymentRequest($id: String!, $input: UpdatePaymentRequestInput!) {
    updatePaymentRequest(id: $id, input: $input) {
      id
      invoiceId
      poNo
      receivingNo
      supplierId
      supplierName
      amount
      currency
      exchangeRate
      dueDate
      priority
      bankAccountDetails {
        bank
        accountNo
      }
      status
      updatedAt
    }
  }
`;

export const DELETE_PAYMENT_REQUEST_MUTATION = gql`
  mutation DeletePaymentRequest($id: String!) {
    deletePaymentRequest(id: $id) {
      id
    }
  }
`;

export const SUBMIT_PAYMENT_REQUEST_MUTATION = gql`
  mutation SubmitPaymentRequest($input: SubmitPaymentRequestInput!) {
    submitPaymentRequest(input: $input) {
      id
      status
      submittedBy
      submittedAt
      externalWorkflow
      approvalData
      flowCaseId
        flowCaseNumber
    }
  }
`;

export const COMPLETE_PAYMENT_REQUEST_PAYMENT_MUTATION = gql`
  mutation CompletePaymentRequestPayment($input: CompletePaymentRequestPaymentInput!) {
    completePaymentRequestPayment(input: $input) {
      id
      status
      payment {
        voucherNumber
        paidAmount
        paymentDate
        method
        reference
      }
      completedBy
      completedAt
    }
  }
`;

export const CANCEL_PAYMENT_REQUEST_MUTATION = gql`
  mutation CancelPaymentRequest($input: CancelPaymentRequestInput!) {
    cancelPaymentRequest(input: $input) {
      id
      status
      cancelledBy
      cancelledAt
    }
  }
`;

export const FAIL_PAYMENT_REQUEST_MUTATION = gql`
  mutation FailPaymentRequest($input: FailPaymentRequestInput!) {
    failPaymentRequest(input: $input) {
      id
      status
    }
  }
`;
